// extracted by mini-css-extract-plugin
module.exports = {"alert":"RecsForm_alert__1Mxn6","icon":"RecsForm_icon__3FMzA","submit":"RecsForm_submit__8ROXo"};